import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  const ms53 = {
    label: "Loan Priority",
    pageLabel: "Loan Priority",
    starting: true,
    url: "ms53",
    pageType: "history",
    form: [
      
    ]
  };
  export default ms53;